export default __webpack_public_path__ + "static/media/travel-guru.ca1e2acf.png";